var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as StackTracey from "stacktracey";
export class LogService {
    constructor() {
    }
    static get instance() {
        let i = LogService._instance;
        if (i == null) {
            i = new LogService();
            LogService._instance = i;
        }
        return i;
    }
    /**
     * Capture js errors,
     * dont hide them,
     * send to error tracking endpoint.
     * */
    registerErrorTracking() {
        window.onerror = (message, source, lineno, colno, error) => __awaiter(this, void 0, void 0, function* () {
            const mappedErrors = error instanceof Error ? yield this.mapError(error) : [{
                    message: message instanceof Event ? undefined : message,
                    source, lineno, colno
                }];
            mappedErrors === null || mappedErrors === void 0 ? void 0 : mappedErrors.forEach(error => this.sendError(error));
            // returning false doesn't prevent the error from bubbling up and showing in console
            return false;
        });
    }
    /**
     * POST error as json to "/api/v1/log-error"
     * */
    sendError(error) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield fetch('/api/v1/log-error', {
                    method: 'POST',
                    body: JSON.stringify(error),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
            }
            catch (e) {
                // since something already went wrong with error logging method
                // the best we can do is just log the error
                console.error(e);
            }
        });
    }
    mapError(error) {
        return __awaiter(this, void 0, void 0, function* () {
            let stack = new StackTracey(error);
            stack.clean();
            stack = stack.withSources();
            return stack.items.map(item => {
                return {
                    message: error.message,
                    source: item.fileShort,
                    colno: item.column,
                    lineno: item.line,
                    line: item.sourceLine
                };
            });
        });
    }
}
